import * as React from 'react';
import styled from 'styled-components';

const InputBaseContainer = ({
  hidden,
  children,
}: InputBaseContainerTypes) => {
  if (Array.isArray(children)) {
    return (
      <InputContainer hidden={hidden}>
        {children.map((element, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <MarginedInputContainer key={index}>
            {element}
          </MarginedInputContainer>
        ))}
      </InputContainer>
    );
  }

  return (
    <InputContainer hidden={hidden}>
      <MarginedInputContainer>
        {children}
      </MarginedInputContainer>
    </InputContainer>
  );
};

const InputContainer = styled.div`
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
  width: calc(100% + 16px);
  padding: var(--input-row-padding-y, 8px) 0;
  margin: 0 -8px;
  text-align: left;
  flex-wrap: wrap;

  @media (max-width: 540px) {
    flex-direction: column;
    width: 100%;
    margin: 0;
  }
`;

const MarginedInputContainer = styled.div`
  margin: 0 8px;
  width: 100%;
  min-width: 0;
  flex: 1 1 0;

  @media (max-width: 540px) {
    margin: 0 0 4px 0;
    flex: 0 1 auto;
  }
`;

interface InputBaseContainerTypes {
  hidden?: boolean;
  children: React.ReactNode | React.ReactNode[];
}

export default InputBaseContainer;
